/**
 * DSettings > "Snap and Grid" tab.
 *
 * Shows functional checkboxes for SNAPMODE and GRIDMODE, bound to
 * sysvarStore. AutoCAD parity: the tab is labelled "Snap and Grid" and
 * exposes the core enable toggles; F9 / F7 shortcuts are documented inline.
 */

import { useT } from "../../i18n";
import { useSysvarStore } from "../sysvarStore";

export function SnapGridTab() {
  const t = useT();
  const snapMode = useSysvarStore((s) => s.values.SNAPMODE);
  const gridMode = useSysvarStore((s) => s.values.GRIDMODE);
  const setVar = useSysvarStore((s) => s.setVar);

  return (
    <div className="dsettings-tab-content">
      {/* ── Snap section ── */}
      <div className="dsettings-section">
        <div className="dsettings-section-title">{t("dsettings.snap.title")}</div>
        <label className="dsettings-checkbox-row">
          <input
            type="checkbox"
            checked={snapMode !== 0}
            onChange={(e) => setVar("SNAPMODE", e.target.checked ? 1 : 0)}
          />
          <span className="dsettings-checkbox-label">
            {t("dsettings.snap.enable")}
          </span>
        </label>
        <p className="dsettings-hint">{t("dsettings.snap.hint")}</p>
      </div>

      {/* ── Grid section ── */}
      <div className="dsettings-section">
        <div className="dsettings-section-title">{t("dsettings.grid.title")}</div>
        <label className="dsettings-checkbox-row">
          <input
            type="checkbox"
            checked={gridMode !== 0}
            onChange={(e) => setVar("GRIDMODE", e.target.checked ? 1 : 0)}
          />
          <span className="dsettings-checkbox-label">
            {t("dsettings.grid.enable")}
          </span>
        </label>
        <p className="dsettings-hint">{t("dsettings.grid.hint")}</p>
      </div>
    </div>
  );
}
